<template>
    <div class="lcu-page-legend">
        <div class="lcu-legend-grid">
          <img
            v-if="!userLoading"
            :src="user.profilePic || '/assets/default-profile.svg'"
            alt="Profile picture"
          class="lcu-legend-pic" />
          <div class="lcu-profileImage-loader" v-if="userLoading">
            <shimmer-circle :size="'60px'" />
          </div>
          <div class="lcu-legend-content">
            <div class="lcu-shimmer-name" v-if="userLoading">
              <shimmer-line />
            </div>
            <span v-if="!userLoading">Bienvenido(a) {{ user.firstName || 'student' }}</span>
            <div class="lcu-legend-breadcrumbs" v-if="breadcrumbs.length > 0 && loading">
              <shimmer-line :width="'35%'"/>
            </div>
            <div class="lcu-legend-breadcrumbs" v-if="!loading">
              <span
                v-for="(crumb, index) in breadcrumbs"
                :key="crumb.text"
                :class="{
                  'lcu-breadcrumb-splitter': index < breadcrumbs.length - 1,
                }">
                <router-link
                  v-if="crumb.link"
                  class="lcu-legend-breadcrumb lcu-breadcrumb-link"
                  :to="crumb.link">
                  {{ crumb.text }}
                </router-link>
                <span v-else class="lcu-legend-breadcrumb">
                  {{ crumb.text }}
                </span>
              </span>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ShimmerLine from 'ç/loaders/shimmers/Line.vue';
import ShimmerCircle from 'ç/loaders/shimmers/Circle.vue';

export default {
  name: 'page-legend',
  components: {
    ShimmerLine,
    ShimmerCircle,
  },
  computed: {
    ...mapGetters(['user', 'userLoading']),
  },
  props: {
    breadcrumbs: {
      type: Array,
      required: false,
      default: () => [],
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-page-legend {
  position: relative;
}

.lcu-shimmer-name {
  width: 100px;
}

.lcu-legend-grid {
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-gap: 25px;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr;
  }
}

.lcu-legend-pic {
  border: 1px solid #ccc;
  border-radius: 50%;
  overflow: hidden;
  width: 60px;

  @media only screen and (max-width: $mobile-max) {
    display: none;
  }
}

.lcu-legend-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: max-content;
  padding-bottom: 10px;
  align-self: center;
  border-bottom: 1px solid #ccc;
}

.lcu-legend-breadcrumbs {
  white-space: nowrap;
  display: flex;
  justify-content: flex-end;
}

.lcu-legend-breadcrumb {
  color: $gray-medium;
}

.lcu-breadcrumb-link {
  color: $legacy-primary;
  opacity: 1;
}

.lcu-breadcrumb-splitter {
  &:after {
    content: '/';
    display: inline-block;
    margin: 0 10px;
  }
}

.lcu-profileImage-loader {

  @media only screen and (max-width: $mobile-max) {
    display: none;
  }
}
</style>
